<script>
import { Line } from "vue-chartjs";
import * as soluhafire from "@/soluhafire";
import * as soluhaApi from "@/soluhaApi";

// plugin agar bisa tambah attribute chartArea Backgroud
const changeBackgroundPlugin = {
  beforeDraw: function (chart) {
    if (
      chart.config.options.chartArea &&
      chart.config.options.chartArea.backgroundColor
    ) {
      var ctx = chart.chart.ctx;
      var chartArea = chart.chartArea;

      ctx.save();
      ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
      ctx.fillRect(
        chartArea.left,
        chartArea.top,
        chartArea.right - chartArea.left,
        chartArea.bottom - chartArea.top
      );
      ctx.restore();
    }
  },
};

export default {
  extends: Line,
  props: ["cabang", "tahun"],
  data() {
    return {
      // variabel yang akan diisi dengan nilai gradient
      tingkatAktivitas: {},
      colorStops: [
        ["#17EAAC", "#45AFEE"],
        ["#FF9F46", "#F18586"],
        ["#17EAAC", "#45AFEE"],
        ["#FF9F46", "#F18586"],
      ],
      datasetTemplate: {
        data: null,
        borderColor: "#80b6f4",
        pointBorderColor: "#80b6f4",
        pointBackgroundColor: "#80b6f4",
        pointHoverBackgroundColor: "#80b6f4",
        pointHoverBorderColor: "#80b6f4",
        pointBorderWidth: 10,
        pointHoverRadius: 10,
        pointHoverBorderWidth: 1,
        pointRadius: 0,
        fill: false,
        borderWidth: 4,
      },
      chartData: {
        labels: soluhafire.NAMA_BULAN_PENDEK,
        datasets: [],
      },
      options: {
        chartArea: {
          backgroundColor: "#F5F6FB",
        },
        bezierCurve: false,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "#A0A3BD",
                fontStyle: "light",
                fontSize: 12,
                beginAtZero: true,
                padding: 10,
                stepSize: 10,
              },
              gridLines: {
                zeroLineColor: "transparent",
                lineWidth: 8,
                color: "#FCFCFC",
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                zeroLineColor: "transparent",
                lineWidth: 8,
                color: "#FCFCFC",
              },
              ticks: {
                padding: 4,
                fontColor: "#A0A3BD",
                fontStyle: "light",
                fontSize: 12,
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    // set grafik size
    this.$refs.canvas.style.width = "712px";
    this.$refs.canvas.style.maxHeight = "200px";

    // add plugin
    this.addPlugin(changeBackgroundPlugin);
    // render chart
    this.setTingkatAktivitas(this.cabang, this.tahun);
  },

  methods: {
    setDatasetColor(i) {
      let gradientStroke = this.$refs.canvas
        .getContext("2d")
        .createLinearGradient(500, 0, 100, 0);
      gradientStroke.addColorStop(0, this.colorStops[i][0]);
      gradientStroke.addColorStop(1, this.colorStops[i][1]);

      this.chartData.datasets[i].borderColor = gradientStroke;
      this.chartData.datasets[i].pointBorderColor = gradientStroke;
      this.chartData.datasets[i].pointBackgroundColor = gradientStroke;
      this.chartData.datasets[i].pointHoverBackgroundColor = gradientStroke;
      this.chartData.datasets[i].pointHoverBorderColor = gradientStroke;
    },
    setTingkatAktivitas(cabang, tahun) {
      soluhaApi
        .getGrafikTingkatAktivitas(cabang, tahun)
        .then((res) => {
          this.tingkatAktivitas = res[0];
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

  watch: {
    cabang: function (newVal, oldVal) {
      this.setTingkatAktivitas(newVal, this.tahun);
    },
    tahun: function (newVal, oldVal) {
      this.setTingkatAktivitas(this.cabang, newVal);
    },

    tingkatAktivitas: function (newVal, oldVal) {
      let i = 0;
      this.chartData.datasets = [];
      for (let cabang in newVal) {
        const data = newVal[cabang];

        this.chartData.datasets.push(soluhafire.deepCopy(this.datasetTemplate));
        this.chartData.datasets[i].data = data;
        this.setDatasetColor(i);
        i++;
      }

      this.renderChart(this.chartData, this.options);
    },
  },
};
</script>
